enum PaymentHistoryActionType {
    //支払い履歴
    GET_PAYMENT_HISTORY_REQUEST = "GET_PAYMENT_HISTORY_REQUEST",
    GET_PAYMENT_HISTORY_SUCCEEDED = "GET_PAYMENT_HISTORY_SUCCEEDED",
    GET_PAYMENT_HISTORY_FAILED = "GET_PAYMENT_HISTORY_FAILED",
}

export default PaymentHistoryActionType
